"use client";
import { useStoreContext } from "@/lib/store";
import { Badge } from "../../atoms/badge";
import { formatCurrency } from "@/lib";

interface Props {
  className?: string;
}

export function ExchangeRate({ className }: Props) {
  const { appSettings } = useStoreContext();
  const dollarToNaira = appSettings?.dollarToNaira ?? 0;
  const yuanToNaira = appSettings?.yuanToNaira ?? 0;
  return (
    <div className={`flex gap-3 ${className || ""}`}>
      <Badge color="primary">
        $1 - {formatCurrency(dollarToNaira * 100, "Naira")}
      </Badge>
      <Badge color="primary">
        ¥1 - {formatCurrency(yuanToNaira * 100, "Naira")}
      </Badge>
    </div>
  );
}
